/* eslint-disable */
import React, { useState, useEffect, useRef } from 'react';
import { getQRcode } from '../../api/invite';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { quitBook, convertObject } from '@/utils/tools';
import {
  DEVICE,
  LIBRARY_XML_ORIGIN_URL,
  LIBRARY_ASSETS_ORIGIN_URL,
  IDENTITY_KEY_NAME,
} from '@/constants';
import { scorm, scormNoAuth, statistic, userInfo } from '@/api';
import RiseLoading from '@/routes/components/Loading';
import {
  callNativeFunction,
  nativeFunction,
  OS,
  getIdentity,
  getOs,
} from '@/utils/detectDevice';
import studentAvatar from '@/assets/images/student_default_avatar.png';
import PlayingBtn from './components/PlayingBtn';
import ShareModal from './components/ShareModal';

let t1 = null;
let t2 = null;
let timer = null;
let books = [];
// 测试
let audioIndexList = [];
let isTouch = true;
const ReadingShare = ({ history, match }) => {
  const [bookData, setBookData] = useState([]);
  const [shareBtn, setShareBtn] = useState(true);
  const [playing, setPlaying] = useState(false);
  const [requestCode, setRequestCode] = useState(0);
  const [cover, setCover] = useState(0);
  const [title, setTitle] = useState('');
  const [avatar, setAvatar] = useState('');
  const [bookIndex, setBookIndex] = useState(0);
  const [uid, setUid] = useState('');
  const [pid, setPid] = useState('');
  const [showShareModal, setShowShareModal] = useState(false);
  const { params } = match;
  const audioRef = useRef(null);
  const [QRcode,setQRcode]=useState('');
  const appName = getIdentity(IDENTITY_KEY_NAME.APP_NAME);

  const XMLToEssay = (xml) => {
    const sectionArr = xml.text[0].p.map(item => item.s);
    const textList = sectionArr.map(item => item.map(sub => sub.w))
      .map(item => item.map(sub => sub.map(({ _text: text }) => text)));
    let text = '';
    textList.forEach((items) => {
      items.forEach((item) => {
        text = `${text} ${item.join(' ')}`;
      });
    });
    books[books.length - 1].text = text;
  };

  const formatAudioUrl = (url) => {
    if (!url) return url;
    return url
      .replace(/^http:\/\//, 'https://')
      .replace(/:9088(?=\/|$)/, '');
  };

  const init = (pages) => {
    books = [];
    pages.forEach((item, index) => {
      const { title_id: fileName } = item;
      const recordUrl = formatAudioUrl(item.record_url);
      books.push({ text: '', src: recordUrl });
      recordUrl && audioIndexList.push(index);
      fileName && XMLToEssay(
        OS.TYPE === DEVICE.PC || params.uid
          ? scorm.xml(`${LIBRARY_XML_ORIGIN_URL}Library/${fileName}/${fileName}.xml`).data
          : scorm.localXml(fileName),
      );
    });
    setBookIndex(0);
    setBookData(books);
  };

  const getScorm = async () => {
    const stageId = params.stageId.split('-')[0];
    const userId = params.uid ? params.uid : getIdentity(IDENTITY_KEY_NAME.UID);
    const reqParams = { ...params, stageId };
    const result = params.uid ? await scormNoAuth.recordShare(reqParams, params.uid) : await scorm.recordShare(reqParams);
    const user = await userInfo.list(userId);
    const { code, data } = convertObject(result);
    setRequestCode(code);
    if (code === 200) {
      setPid(data[0].parent_id);
      console.log('pid',data[0].parent_id);
      setAvatar(user && user.code === 200 && user.data[0] ? user.data[0].avatar : '');
      init(data[0].page.filter(item => item.vms_sco_type === 'SRS'));
      const { title_id: titleId } = data[0].page[0];
      setCover(`${LIBRARY_ASSETS_ORIGIN_URL}Library/${titleId}/${titleId}_Image.png`);
      setTitle(data[0].fullname);
      getQRcode(data[0].parent_id?data[0].parent_id:params.pid,params.uid ? params.uid : getIdentity(IDENTITY_KEY_NAME.UID)).then((res)=>{
        getImageInfoFromBase64(res.data);
      });
    };
  };

  const postAddUserShare = async (type) => {
    const userId = params.uid ? params.uid : getIdentity(IDENTITY_KEY_NAME.UID);
    callNativeFunction(nativeFunction.TO_SHARE)({
      url: `${window.location.href}/${userId}/${pid}`,
      title,
      description: `${window.location.href}/${userId}/${pid}`,
      thumb: cover,
      type,
    });
    console.log('postAddUserShare',`${window.location.href}/${userId}/${pid}`);
    statistic.post({ share: 1 });
  };

  const handleShare = (type) => {
    setShareBtn(false);
    postAddUserShare(type);
  };

  const handleClose = () => quitBook({ params, push: history.push });

  

  // 翻页滚到当前页
  const ScrollTop = (number = 0, time) => {
    if (!time) {
      document.querySelector('.book-content').scrollTop = number;
      return number;
    }
    const spacingTime = 20; // 设置循环的间隔时间  值越小消耗性能越高
    let spacingIndex = time / spacingTime; // 计算循环的次数
    let nowTop = document.querySelector('.book-content').scrollTop; // 获取当前滚动条位置
    const everTop = (number - nowTop) / spacingIndex; // 计算每次滑动的距离
    const scrollTimer = setInterval(() => {
      if (spacingIndex > 0) {
        spacingIndex -= 1;
        ScrollTop(nowTop += everTop);
      } else {
        clearInterval(scrollTimer); // 清除计时器
      }
    }, spacingTime);

  };
  const isScrollEnd = () => {
    // 只有触摸滑动走此方法
    if (isTouch) {
      t2 = document.documentElement.scrollTop || document.body.scrollTop;
      const bookText = document.querySelector('.book-content');
      const topHeight = appName === 'PARENT' || OS.TYPE === DEVICE.MOBILE ? document.querySelector('.reading-share-bookCover').clientHeight : 0;
      let index = 0;
      if (t2 === t1) {
        bookData.forEach((item, i) => {
          const currentDom = document.getElementById(`page${i}`);
          currentDom.offsetTop - topHeight - 30 <= bookText.scrollTop && (index = i);
        })
      }
      setBookIndex(index);
      playing && audioIndexList.indexOf(index) > -1 && setTimeout(() => audioRef.current.play(), 0);
      if (playing && !(audioIndexList.indexOf(index) > -1)) {
        setPlaying(false);
        audioRef.current.pause();
      }
    } else {
      isTouch = true;
      playing && audioIndexList.indexOf(bookIndex) > -1 && setTimeout(() => audioRef.current.play(), 0);
    }
  };

  // 字幕切换
  const changeScrollTop = (index) => {
    const topHeight = appName === 'PARENT' || OS.TYPE === DEVICE.MOBILE ? document.querySelector('.reading-share-bookCover').clientHeight : 0;
    const currentDom = document.getElementById(`page${index}`);
    const bookText = document.querySelector('.book-content');
    if (bookText.scrollTop + bookText.clientHeight + 25 >= bookText.scrollHeight && currentDom.offsetTop - topHeight > bookText.scrollTop) {
      setBookIndex(index);
      playing && setTimeout(() => audioRef.current.play(), 0);
    } else {
      isTouch = false;
      ScrollTop(currentDom.offsetTop - topHeight - 25, 200);
    }
  };

  const handleScroll = () => {
    audioRef.current.pause();
    clearTimeout(timer);
    timer = setTimeout(isScrollEnd, 80);
    t1 = document.documentElement.scrollTop || document.body.scrollTop;
  };

  const playingSetIndex = (index) => {
    let currentIndex = 0;
    if (audioIndexList.indexOf(index) > -1) {
      currentIndex = index;
    } else if (audioIndexList.filter(item => item > bookIndex).length > 0) {
      currentIndex = audioIndexList.filter(item => item > bookIndex)[0];
    }
    else {
      currentIndex = audioIndexList[0];
    }
    audioRef.current.src = bookData[currentIndex].src;
    changeBookIndex(currentIndex);
  };

  const handlePlay = () => {
    if (!playing) {
      setPlaying(true);
      audioRef.current.src = bookData[bookIndex].src;
      audioRef.current.play();
    } else {
      setPlaying(false);
      audioRef.current.pause();
    }
  };

  const handleAudioEnd = () => playingSetIndex(bookIndex + 1);

  const changeBookIndex = (index) => {
    setBookIndex(index);
    changeScrollTop(index);
    if (playing && !(audioIndexList.indexOf(index) > -1)) {
      setPlaying(false);
      audioRef.current.pause();
    }
  };
   // 将 base64 数据转换为临时文件路径
 const base64ToTempFilePath_H5=(base64Data)=>{
  return new Promise((resolve, reject) => {
    // H5 环境下使用 Blob 对象
    const byteCharacters = atob(base64Data);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: "image/png" });
    const tempFilePath = URL.createObjectURL(blob);
    resolve(tempFilePath);
  });
};
  // 调用getImageInfo方法并传入临时文件路径
  const  getImageInfoFromBase64=async(base64Data)=>{
    try {
      let tempFilePath;
      tempFilePath = await base64ToTempFilePath_H5(base64Data);
      console.log("获取到的图片信息：", tempFilePath);
      setQRcode(tempFilePath);
    } catch (error) {
      console.error("获取图片信息失败：", error);
    }
  };

  useEffect(() => {
    setUid(params.uid ? params.uid : null);
    setPid(params.pid? params.pid:null);
    // params.uid && import('./styleShare.less');
    const Os = getOs();
    appName === 'PARENT' || Os === DEVICE.MOBILE
      ? import('./style.less')
      : import('./stylePc.less');
    appName === '' && Os !== DEVICE.MOBILE && window.resizeTo(1024,768);
    getScorm();
    window.onfire.on('shareEnd', () => setShareBtn(true));
    return () => {
      window.onfire.off('shareEnd');
    }
  }, []);

  return (
    <div className="reading-share">
      {requestCode === 0 ? <RiseLoading /> : null}
      <div className={`reading-share-wrapper${uid ? ' top' : ''}`}>
        <div className="reading-share-bookCover">
          <div className={`bookCover-wrapper${uid ? ' top' : ''}`}>
            {!uid && <div className="reading-share-header">
              <div className="reading-share-close" onClick={handleClose} />
              <div className="share-btn" onClick={() => setShowShareModal(true)} />
            </div>}
            <div className="cover">
              <img src={cover} alt="" />
            </div>
            <div className="book-pedestal" />
            <div className="bookName">{title}</div>
            <div className="rise-logo" />
            {appName !== 'PARENT' && !uid && <div className="share-btn-wrapper">
              <div className="moments" onClick={shareBtn ? () => handleShare('WEIXIN_CIRCLE') : undefined} />
              <div className="friend" onClick={shareBtn ? () => handleShare('WEIXIN') : undefined} />
            </div>}
            {uid &&<div className="share-invite">
            <img className="invite" src={QRcode} alt=""/>
            </div>}
          </div>
        </div>
        <div className="book-content" onScroll={handleScroll}>
          {
            bookData && bookData.map((item, index) => (
              <div id={`page${index}`} className={`page${bookIndex === index ? ' current' : ''}`} key={`${index + 1}`}>
                {item.text}
              </div>
            ))
          }
          <div className="placeholder" />
        </div>
        {bookData && bookData.length > 0 && 
          <div className="reading-share-flip">
            <div className="user-avatar"><img src={avatar ? avatar : studentAvatar} alt="" /></div>
            <div className="page-up" onClick={bookIndex !== 0 ? () => changeBookIndex(bookIndex - 1) : null}><div className={`page-up-btn${bookIndex === 0 ? ' dis' : ''}`} /></div>
            <div className="page-num">
              <span className="current-page">{bookIndex + 1}</span>
              <span>{` / ${bookData.length}`}</span>
            </div>
            <div className="page-down" onClick={bookIndex + 1 !== bookData.length ? () => changeBookIndex(bookIndex + 1) : null}><div className={`page-down-btn${bookData.length === bookIndex + 1 ? ' dis' : ''}`} /></div>
            <div className={`reading-share-play-btn${playing ? ' playing' : ''}${!bookData[bookIndex].src && !playing ? ' dis' : ''}`} onClick={bookData[bookIndex].src || playing ? () => handlePlay() : null}>{playing && <PlayingBtn />}</div>
          </div>
        }
      </div>
      <div className="reading-share-modal">
        <div className="moments" onClick={shareBtn ? () => handleShare('WEIXIN_CIRCLE') : undefined} />
        <div className="friend" onClick={shareBtn ? () => handleShare('WEIXIN') : undefined} />
      </div>
      <audio
        onEnded={handleAudioEnd}
        ref={audioRef}
        src={bookData && bookData[bookIndex] && bookData[bookIndex].src ? bookData[bookIndex].src : null}
      />
      {showShareModal && <ShareModal isShow={showShareModal} hide={() => setShowShareModal(false)} fade={showShareModal ? 'fade-in' : 'fade-out'} share={handleShare} shareBtn={shareBtn} />}
    </div>
  );
};

ReadingShare.propTypes = {
  history: PropTypes.object.isRequired,
  match: PropTypes.object,
};

export default withRouter(ReadingShare);
